import Vue from "vue";
import Vuex from "vuex";
import { stat } from "fs";

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    loggedIn: false,
    allbars: [],
    currentBar: {},
    page: 1,
    hasNextPage: false,
    hasPrevPage: false
  },
  getters: {},
  mutations: {
    logIn(state, payload) {
      state.loggedIn = payload.loggedIn;
    },
    setBars(state, payload) {
      state.allbars = payload.payload;
    },
    updateBar(state, payload) {
      let cloneArray = [...state.allbars];
      cloneArray.forEach((item, index) => {
        if (item._id === payload.payload._id) {
          cloneArray[index] = payload.payload;
        }
      });
      state.allbars = cloneArray;
    },
    addBar(state, payload) {
      state.allbars.push(payload.payload);
    },
    removeBar(state, payload) {
      state.allbars = state.allbars.filter(
        bar => bar._id !== payload.payload._id
      );
    },
    setCurrentBar(state, payload) {
      state.currentBar = payload.currentBar;
    },
    nextPage(state) {
      state.page = state.page + 1;
    },
    prevPage(state) {
      state.page = state.page - 1;
    },
    setHasNextPage(state, payload) {
      state.hasNextPage = payload.payload;
    },
    setHasPrevPage(state, payload) {
      state.hasPrevPage = payload.payload;
    }
  },
  actions: {},
  modules: {}
});
